// for mail
import { MessageBox, Message } from "element-ui";
import { readAsBinaryString } from "../utils/file.js";
import {
  uploadDeliveryInfo,
  logisticsUpdate,
  getExcelTemplate
} from "@/services/fulfillment-api";

import postDownload from "../utils/download";

export default {
  data() {
    return {
      importVisible: false,
      mailDialogVisible: false,
      logisticsList: [],
      fileList: []
    };
  },
  methods: {
    // 显示 import 快递dialog
    showImportDialog() {
      if (!this.selectedIds.length) {
        Message(this.$t("ffm_pls_select_an_order"));
        return;
      }
      this.importVisible = true;
    },
    // 显示 mail dialog
    showMailDialog(row, isremail, remailType = "order") {
      const status = this.$refs.showOriginal && this.$refs.showOriginal.status;
      this.editingRow = row;
      this.mailDialogVisible = true;
      if (isremail) {
        this.isremail = isremail;
        this.remailType = remailType;
        this.$nextTick(_ => {
          // 修改物流信息
          let info = remailType === "unit" ? row : row.order_base_info;
          this.$refs.mailForm.modelData = this.config.mail_form.model = {
            tracking_website: info.tracking_website || "",
            tracking_no: status === 1 ? info.logistics_no || "" : ""
          };
        });
      }
    },
    // 上传, 前端解析excel
    uploadContent(e) {
      let file = e.target.files[0];
      let item = {
        name: file.name,
        status: "uploading",
        percentage: 0,
        type: file.type
      };
      this.fileList.push(item);
      readAsBinaryString(file)
        .then(rows => {
          this.logisticsList = this.logisticsList.concat(rows);
          item.percentage = 100;
          item.status = "success";
          this.$refs["content_file_input"].value = "";
        })
        .catch(e => {
          this.fileList = [];
          this.logisticsList = [];
          Message({
            message: this.$t("ffm_file_not_support"),
            type: "warning"
          });
        });
    },
    // 批量mail
    async batchMail() {
      if (!this.fileList.length) {
        Message(this.$t("ffm_pls_upload_file"));
        return;
      }
      let data = this.logisticsList.map(item => {
        return {
          booking_reference_no: String(item["Booking Reference ID"] || ""), // booking_reference_no,
          mailing_address: String(item["Mailing Address"] || ""), // 收货地址,
          post_code: String(item["Post Code"] || ""), // 邮政编码,
          ticket_receiver: String(item["Ticket Receiver"] || ""), // 收货人,
          tracking_no: String(item["Tracking No"] || ""), // 物流单号,
          tracking_website: String(item["Tracking Website"] || ""), // 物流网站,
          voucher_no: String(item["Voucher No"] || "")
        };
      });

      try {
        let res = (await uploadDeliveryInfo(data)).result;
        if (res.empty_type || res.error_status || res.error_type) {
          const h = this.$createElement;
          MessageBox({
            closeOnClickModal: false,
            message: h("p", null, [
              h("p", { class: "import-err-message" }, res.empty_type),
              h("p", { class: "import-err-message" }, res.error_status),
              h("p", { class: "import-err-message" }, res.error_type)
            ])
          });
        } else {
          Message(this.$t("ffm_operation_successful"));
        }
        this.search();
        this.importVisible = false;
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      } finally {
        this.logisticsList = [];
      }
    },
    // mail / 区分 打印order or unit
    mail() {
      // 打印order
      this.editingRow.hasOwnProperty("checked")
        ? this.mailOrder(this.editingRow)
        : this.mailUnit(this.editingRow);
    },
    // 重新邮寄
    remail(remailType) {
      // 修改物流信息
      remailType === "order" ? this.remailOrder() : this.remailUnit();
      this.isremail = false;
    },
    // mail order
    async mailOrder(order) {
      let model = this.$refs.mailForm.modelData;
      if (!model.tracking_website || !model.tracking_no) {
        Message(this.$t("ffm_check_mail_empty"));
        return;
      }
      let info = order.order_base_info;
      let data = [
        {
          booking_reference_no: String(info.booking_reference_no), // booking_reference_no,
          mailing_address: String(info.mailing_address), // 收货地址,
          post_code: String(info.post_code), // 邮政编码,
          ticket_receiver: String(info.ticket_receiver), // 收货人,
          tracking_website: String(model.tracking_website),
          tracking_no: String(model.tracking_no),
          voucher_no: String(info.voucher_no)
        }
      ];
      try {
        let res = (await uploadDeliveryInfo(data)).result;
        if (res.error_status || res.error_type) {
          const h = this.$createElement;
          MessageBox({
            closeOnClickModal: false,
            message: h("p", null, [
              h("p", { class: "import-err-message" }, res.error_status),
              h("p", { class: "import-err-message" }, res.error_type)
            ])
          });
        } else {
          Message(this.$t("ffm_operation_successful"));
        }
        this.search();
        this.mailDialogVisible = false;
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    },
    // mail unit
    async mailUnit(unit) {
      let model = this.$refs.mailForm.modelData;
      if (!model.tracking_website || !model.tracking_no) {
        Message(this.$t("ffm_check_mail_empty"));
        return;
      }
      let params = {
        order_base_id: Number(unit.order_base_id), // booking_reference_no,
        tracking_website: String(model.tracking_website),
        tracking_no: String(model.tracking_no),
        unit_file_id: Number(unit.id)
      };
      try {
        await logisticsUpdate(params);
        this.mailDialogVisible = false;
        this.search();
        Message(this.$t("ffm_operation_successful"));
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    },
    // 修改物流信息
    async remailOrder() {
      let model = this.$refs.mailForm.modelData;
      if (!model.tracking_website || !model.tracking_no) {
        Message(this.$t("ffm_check_mail_empty"));
        return;
      }
      let params = {
        order_base_id: Number(this.editingRow.order_base_info_id), // booking_reference_no,
        tracking_website: String(model.tracking_website),
        tracking_no: String(model.tracking_no)
      };
      try {
        await logisticsUpdate(params);
        this.mailDialogVisible = false;
        this.search();
        Message(this.$t("ffm_operation_successful"));
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    },
    // remail unit
    async remailUnit() {
      let model = this.$refs.mailForm.modelData;
      if (!model.tracking_website || !model.tracking_no) {
        Message(this.$t("ffm_check_mail_empty"));
        return;
      }
      let params = {
        order_base_id: Number(this.editingRow.order_base_id), // booking_reference_no,
        tracking_website: String(model.tracking_website),
        tracking_no: String(model.tracking_no),
        unit_file_id: Number(this.editingRow.id)
      };
      try {
        await logisticsUpdate(params);
        this.mailDialogVisible = false;
        this.search();
        Message(this.$t("ffm_operation_successful"));
      } catch (err) {
        Message(this.$t("ffm_operation_failed"));
      }
    },
    // 是否重新上传
    checkMailStatus() {
      // 不是修改物流信息
      this.isremail ? this.remail(this.remailType) : this.mail();
    },
    // 删除上传的文件
    handleRemove(index) {
      this.fileList.splice(index, 1);
      this.logisticsList = [];
    },
    // 下载模板
    async downloadTemplate() {
      let data = this.selectedItems.map(v => {
        let o = v.order_base_info;
        return {
          booking_reference_no: o.booking_reference_no, // booking_reference_no,
          mailing_address: "", // 收货地址,
          post_code: "", // 邮政编码,
          ticket_receiver: "", // 收货人,
          tracking_no: "", // 物流单号,
          tracking_website: "", // 物流网站,
          voucher_no: o.voucher_no // voucher_no,
        };
      });
      try {
        let res = await getExcelTemplate(data);
        postDownload("template.xlsx", res);
      } catch (err) {
        // 失败, 下载本地模板
        console.log("err:", err);
        Message.error("Download Template Fail");
      }
    }
  },
  watch: {
    mailDialogVisible(next) {
      if (!next) {
        this.$refs.mailForm.modelData = {
          tracking_website: "",
          tracking_no: ""
        };
        this.config.mail_form.model = {
          tracking_website: "",
          tracking_no: ""
        };
      }
    }
  }
};
